import $ from 'jquery';

export default {

	init() {

		const carouselGallery = $('.js-carousel-events');

		if (carouselGallery.length > 0) {
			carouselGallery.slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				centerPadding: '25%',
				centerMode: true,
				adaptiveHeight: true,
				arrows: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							dots: true,
							centerMode: true,
							adaptiveHeight: true,
							centerPadding: '40px',
							slidesToShow: 1
						}
					},
				]
			  });
		}

	}

};
